import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Select as SelectMUI } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import RevolutCheckout from '@revolut/checkout';
import axios from "axios";
import { push } from "connected-react-router";
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import * as React from 'react';
import { SpinnerComponent } from 'react-element-spinner';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { default as Select } from 'react-select';
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { validateEmail, validateNumber, ValidateSelect } from '../../Helpers/DataHelpers';
import { Login, Logout, UpdateZendeskID } from '../../redux/actions/AuthActions';
import { IStore, IUserData } from '../../redux/constants';

const mapStateToProps = (state: IStore) => ({
    userData: state.auth.UserData,
    lang: state.language.value,
    history: state.history,
    URL: state.auth.UserData.yoonitGetURL,
    theme: state.theme,
    CompanyData: state.CompanyData,
});
let Options = [{ value: "EUR", label: "EUR" }]

const dispatchProps = { push, Login, Logout, UpdateZendeskID }
export interface TicketsPageProps {
    lang: string;
    userData: IUserData;
    push: any;
    URL: string;
    theme: any;
    t: any;
}

export interface TicketsPageState {
    isLoading: boolean;
    Options: any;
    SelectedValue: BasicSelectOption;
    amount: number;
    email: string;
}
export class BasicSelectOption {
    value: string | number = -1;
    label: string = "choose";

}
//#region types
class RevolutCheckoutError {
    type: string = "";
    message: string = "";
    code?: number = 0;
}

class RevoultOptions {
    onSuccess?: () => void = () => { };
    onError?: (error: RevolutCheckoutError) => void = () => { };
    onCancel?: () => void = () => { };
    name?: string = "";
    email?: string = "";
    phone?: string = "";
    locale?: string = "";
    savePaymentMethodFor?: string = "";
    billingAddress?: {
        countryCode: "",
        region?: "",
        city?: "",
        postcode: "",
        streetLine1?: "",
        streetLine2?: "",
    };

};
//#endregion
class Pay extends React.Component<TicketsPageProps, TicketsPageState> {
    state = {
        isLoading: false,
        Options: [],
        SelectedValue: new BasicSelectOption(),
        amount: 0,
        email: "",


    }
    componentDidMount() {
        this.CurrencybOpt(Options);
    }
    CurrencybOpt = (CurrencyOptions: any) => {
        var _currOptions = [];
        for (var k = 0; k < CurrencyOptions.length; k++) {
            _currOptions.push({ value: CurrencyOptions[k].value, label: CurrencyOptions[k].label });
        }
        this.setState({ Options: _currOptions, SelectedValue: _currOptions[0] });
    }
    CurrencyOnChange = (SelectedValue: any) => {
        this.setState({ SelectedValue })
    }
    inputOnchange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value } as any)
    }

    checkout = () => {
        if (!this.ValidatePayment()) {
            toastr.error('', this.props.t('FillRequiredFields'));
        } else {
            this.setState({ isLoading: true });
            axios.post<string>("api/Auth/InitPayment", {
                Token: this.props.userData.Token,
                Amount: this.returnAmountWithTVA() * 100,
                Email: this.state.email,
                Currency: this.state.SelectedValue.value
            })
                .then(res => {
                    if (res && res.data) {
                        //public key to sue 
                        let _options = new RevoultOptions();
                        RevolutCheckout(res.data, 'prod').then((instance: any) => {
                            // Work with instance:

                            _options.name = "Test";
                            _options.email = this.state.email;
                            _options.onSuccess = () => {
                                toastr.success('', this.props.t('Success'));
                                this.props.push("/success");

                            }
                            _options.onError = (e: RevolutCheckoutError) => {
                                toastr.error('', this.props.t('FailedAction'));
                                console.error("instance onError", e)
                            }
                            var popup = instance.payWithPopup(_options);

                            //popup.destroy();
                        });

                    }

                })
                .catch((e: any) => {
                    console.error("InitPayment", e);
                });
            this.setState({ isLoading: false });
        }
    }
    ValidatePayment = () => {
        return (validateNumber(+this.state.amount) && +this.state.amount > 0)
            && validateEmail(this.state.email)
            && ValidateSelect(this.state.SelectedValue);
    }

    render() {
        return (<div className="mt-3">
            <SpinnerComponent loading={this.state.isLoading} position="inline" color="#00ad0f" />
            <div className=" d-flex flex-column justify-content-center mx-auto" style={{ height: 'calc(100vh - 200px)'}}>
                <Row>
                    <Col className=" p-3 col-md-6 m-auto">
                        <h2 className="mainTitle t-bold" > Payment </h2>
                    </Col>
                </Row>


                <div className="tableDiv p-3 col-md-6 m-auto">
                    <Row>
                        <Col col-md={12}>
                            <FormGroup >
                                <SelectMUI
                                    style={{ width: '100%' }}
                                    displayEmpty
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    disabled
                                    renderValue={(value: any) => {
                                        return (
                                            <Box style={{ display: "flex", alignItems: 'center', gap: 1, height: '30px' }}>
                                                <img src="https://assets.revolut.com/website/assets/revolut-logo.svg" className="revolutImg" width={130} style={{ width: '130px !important' }} />
                                                Payment
                                            </Box>
                                        );
                                    }}
                                >
                                </SelectMUI>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col col-md={12}>
                            <FormGroup >
                                <SelectMUI
                                    style={{ width: '100%' }}
                                    displayEmpty
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth-depositTo"
                                    disabled
                                    renderValue={() => {
                                        return (
                                            <div style={{ paddingLeft: '10px', marginTop: '5px' }}> <label> Deposit </label></div>
                                        );
                                    }}
                                >
                                </SelectMUI>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col col-md={12}>
                            <FormGroup >
                                <Label for="amount" className="LabelCreate2 d-contents  font-14" > {this.props.t('Amount')}: </Label>
                                <Input
                                    type="number"
                                    name="amount"
                                    bsSize="lg"
                                    className="Inputs"
                                    onChange={this.inputOnchange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col col-md={12}>
                            <FormGroup >
                                <Label for="currency" className="LabelCreate2 d-contents  font-14" > {this.props.t('Currency')}: </Label>
                                <Select
                                    className="react-select-container LargeSelect"
                                    classNamePrefix="react-select cursor-pointer LargeSelect DarkSelect "
                                    isSearchable={false}
                                    isMulti={false}
                                    getOptionLabel={(option: any) => this.props.t(option.label)}
                                    options={this.state.Options}
                                    value={this.state.SelectedValue}
                                    onChange={this.CurrencyOnChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col col-md={12}>
                            <FormGroup >
                                <Label for="email" className="LabelCreate2 d-contents  font-14" > {this.props.t('Email')}: </Label>
                                <Input
                                    type="text"
                                    name="email"
                                    bsSize="lg"
                                    className="Inputs"
                                    onChange={this.inputOnchange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>  <Row>
                        <Col col-md={12}>
                            <FormGroup >
                                <Label for="email" className="LabelCreate2 d-contents  font-14" >
                                    <FontAwesomeIcon icon={faExclamationCircle} className="cursor-pointer mr-1" />
                                    Please note there an additional 2.5% fee is added to the deposit amount.This will bring the total amount to €{this.returnAmountWithTVA()}
                                </Label>
                               
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className="d-flex align-items-end justify-content-end mb-2">
                        <Button className="ButtonsModal AddBtn" onClick={this.checkout} > Deposit </Button>
                    </div>
                </div>
            </div>
        </div>
        )

    }


     returnAmountWithTVA =()=> {
        const _amount = +(this.state.amount||0)
        return _amount + (_amount * 0.025);
    }
}
export default withTranslation()(connect(mapStateToProps, dispatchProps)(Pay));
